import { AppDialog } from '@/components/AppDialog'
import { LazyImage } from '@/components/LazyImage'
import { cn } from '@/lib/utils'

interface Props {
  photos: string[]
  isOpen: boolean
  onOpenChange: (open: boolean) => void
}
export const PhotoListDialog = ({ photos, isOpen, onOpenChange }: Props) => {
  const hasMultiplePhotos = photos.length > 1
  return (
    <AppDialog
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      title={hasMultiplePhotos ? `תמונות החבילה (${photos.length})` : 'תמונת החבילה'}
      titleClassName='px-8'
      dialogContentClassName={hasMultiplePhotos ? 'max-w-6xl' : 'max-w-3xl'}
    >
      <div
        className={cn('grid gap-4', hasMultiplePhotos ? 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-2' : 'grid-cols-1 justify-items-center')}
      >
        {photos.map((photoUrl, index) => (
          <a
            key={index}
            href={photoUrl}
            target='_blank'
            rel='noopener noreferrer'
            download
            className={cn(
              'group relative block overflow-hidden rounded-lg border border-gray-200 transition-shadow hover:shadow-lg',
              hasMultiplePhotos ? 'w-full' : 'w-full max-w-md'
            )}
          >
            <LazyImage src={photoUrl} alt={`תמונה ${index + 1}`} aspectRatio='square' containerClassName='rounded-lg' />
            <div className='absolute inset-0 flex items-center justify-center bg-black/0 transition-colors group-hover:bg-black/10'>
              <span className='text-sm font-medium text-white opacity-0 transition-opacity group-hover:opacity-100'>לחץ להורדה</span>
            </div>
          </a>
        ))}
      </div>
    </AppDialog>
  )
}
